import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { authAPI } from '../api';

export default function ResetPasswordPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authAPI.resetPassword({ token, password });
      toast.success('Mot de passe mis a jour !');
      navigate('/login');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Lien expire');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--bg)', padding:20 }}>
      <div style={{ background:'var(--surface)', border:'1px solid var(--border)', borderRadius:24, padding:48, width:'100%', maxWidth:440 }}>
        <h2 style={{ fontFamily:'Syne,sans-serif', fontWeight:700, marginBottom:24 }}>Nouveau mot de passe</h2>
        <form onSubmit={handleSubmit}>
          <input type="password" required minLength={6} value={password} onChange={e => setPassword(e.target.value)}
            placeholder="Nouveau mot de passe (min. 6)"
            style={{ width:'100%', background:'var(--surface2)', border:'1px solid var(--border)', borderRadius:10, padding:'13px 16px', color:'var(--text)', fontSize:15, outline:'none', marginBottom:16 }} />
          <button type="submit" disabled={loading}
            style={{ width:'100%', padding:14, background:'var(--accent)', color:'#fff', border:'none', borderRadius:10, fontFamily:'Syne,sans-serif', fontWeight:700 }}>
            {loading ? 'Mise a jour...' : 'Mettre a jour'}
          </button>
        </form>
      </div>
    </div>
  );
}